import meta from './meta.json';
import mostSearchedServices from './mostSearchedServices.json';
import faqCallToAction from './faqCallToAction.json';

export { meta, mostSearchedServices, faqCallToAction };
